import React, { useState, useEffect } from 'react';

const ItemModal = ({ item, isOpen, onClose, onSave }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(item);
  }, [item]);

  useEffect(() => {
    if (data) {
      const qty = data.qty || 0;
      const rate = data.rate || 0;
      const discPercent = data.discPercent || 0;

      const discAmount = rate * (discPercent / 100);
      const discountedRate = rate - discAmount;
      const listAmount = qty * discountedRate;

      const taxPercent = data.taxPercent || 0;
      const taxAmount = listAmount * (taxPercent / 100);
      const netAmount = listAmount + taxAmount;

      if (data.discAmount !== discAmount || data.taxAmount !== taxAmount || data.netAmount !== netAmount) {
        setData(d => ({ ...d, discAmount, listAmount, taxAmount, netAmount }));
      }
    }
  }, [data]);

  if (!isOpen || !data) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData(d => ({ ...d, [name]: name === 'desc' ? value : parseFloat(value) || 0 }));
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-2xl space-y-4">
        <h2 className="text-xl font-bold">Add/Edit Item</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div><label className="block text-sm">Item No:</label><p className="p-2 bg-gray-100 rounded">{data.itemNo}</p></div>
          <div><label className="block text-sm">Make:</label><p className="p-2 bg-gray-100 rounded">{data.make}</p></div>
          <div className="md:col-span-2"><label className="block text-sm">Description:</label><input type="text" name="desc" value={data.desc} onChange={handleChange} className="w-full p-2 border rounded" /></div>
          <div><label className="block text-sm">HSN Code:</label><p className="p-2 bg-gray-100 rounded">{data.HSN}</p></div>
          <div><label className="block text-sm">Qty:</label><input type="number" name="qty" value={data.qty} onChange={handleChange} className="w-full p-2 border rounded" /></div>
          <div><label className="block text-sm">Rate:</label><input type="number" name="rate" value={data.rate} onChange={handleChange} className="w-full p-2 border rounded" /></div>
          <div><label className="block text-sm">Discount %:</label><input type="number" name="discPercent" value={data.discPercent} onChange={handleChange} className="w-full p-2 border rounded" /></div>
          <div><label className="block text-sm">Discount Amt:</label><p className="p-2 bg-gray-100 rounded">{data.discAmount?.toFixed(2)}</p></div>
          <div><label className="block text-sm">Tax %:</label>
            <select name="taxPercent" value={data.taxPercent} onChange={handleChange} className="w-full p-2 border rounded">
              <option value={0}>0%</option><option value={5}>5%</option><option value={12}>12%</option><option value={18}>18%</option><option value={28}>28%</option>
            </select>
          </div>
          <div><label className="block text-sm">Tax Amt:</label><p className="p-2 bg-gray-100 rounded">{data.taxAmount?.toFixed(2)}</p></div>
          <div className="md:col-span-2 text-right"><label className="block text-lg font-semibold">Net Amount:</label><p className="text-2xl font-bold text-indigo-600">{data.netAmount?.toFixed(2)}</p></div>
        </div>
        <div className="flex justify-end space-x-3 pt-4 border-t">
          <button onClick={onClose} className="px-4 py-2 bg-gray-300 rounded">Cancel</button>
          <button onClick={() => onSave(data)} className="px-4 py-2 bg-green-600 text-white rounded">Save Item</button>
        </div>
      </div>
    </div>
  );
};

export default ItemModal;
